import {
  IADShowHide,
  NullableAnyObject,
  displayShowWhenHideWhenLabel,
  getSelectedConfig,
} from 'layout/utils-show-hide.js';
import { ColumnLayoutContext } from 'page-context/column-layout/column-layout-context.js';
import { useContext, useEffect, useState } from 'react';

/** Return elements that follow show hide rules */
export const useLayoutConfig = <T extends NullableAnyObject = {}>(
  configs: IADShowHide<T>[],
): IADShowHide<T> | undefined => {
  const columnLayout = useContext(ColumnLayoutContext);
  const [config, setConfig] = useState<IADShowHide<T>>();
  useEffect(() => {
    const selected = getSelectedConfig(configs, columnLayout);
    setConfig(selected);
  }, [columnLayout, configs]);

  return config;
};

export const useShouldDisplayShowHideHook = <T extends IADShowHide>(config: T): boolean => {
  const columnLayout = useContext(ColumnLayoutContext);
  return displayShowWhenHideWhenLabel(config, columnLayout);
};
